import React from 'react';
import Loadable from 'react-loadable';

export const LoadableDateRangePicker = Loadable({
  loader: () => import('./content'),
  loading: () => null,
});

const DateRangePicker = props => <LoadableDateRangePicker {...props} />;

export default DateRangePicker;



// WEBPACK FOOTER //
// ./app/src/containers/DateRangePicker/index.jsx